import React from 'react';
import API from '../../../functions/api';
import { gtmPush } from '../../../functions/gtm';
import smoothScroll from '../../../functions/smoothScroll';
import ModelModule from '../../../components/ModelModule';
import Select from '../../../audi-ui-components/Select';
import Spinner from '../../../audi-ui-components/Spinner';
import { PrimaryButton, TextButton } from '../../../audi-ui-components/Button';
import IconCubicCapacity from '../../../audi-ui-components/icons/CubicCapacity';
import IconPower from '../../../audi-ui-components/icons/Power';
import IconTorque from '../../../audi-ui-components/icons/Torque';
import IconVelocity from '../../../audi-ui-components/icons/Velocity';
import _find from 'lodash/find';
import {
    STATES_OPTIONS
} from '../../../constants';

const FEATURE_STATS = false;

class StepVehicle extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modelId: props.modelId || "",
            variantId: props.variantId || "",
            engineId: props.engineId || "",
            selectedModel: null,
            selectedVariant: null,
            locState: props.locState || "",
            engineOpts: [],
            isFetchingEngines: false,
            prices: {},
            isFetchingPrices: false,
            pricesError: false,
            showErrors: false
        };
    }

    componentDidMount() {
        const {variantId, engineId, locState} = this.state;
        if (variantId && engineId && locState) {
            this.getPrices();
        }
        gtmPush("afsCalculator", "StageLoaded", "AfsCalConfirmAVehicle");
    }

    handleChangeVariant = (field, v, opt) => {
        // console.log("handleChangeVariant", field, v);
        // model
        if (field === 'modelId') {
            if (!v || v === null) {
                this.setState({modelId: v, selectedModel: null});
            } else {
                this.setState({modelId: v, selectedModel: opt});
            }
        }
        // variant
        if (field === 'variantId') {
            if (!v || v === null) {
                return this.setState({variantId: v, selectedVariant: null, engineId: "", engineOpts: [], pricesError: false});
            }
            this.setState({isFetchingEngines: true, variantId: v});
            this.setState({isFetchingEngines: true, variantId: v, selectedVariant: opt});
            API.post(`${process.env.RAZZLE_GQLAPI}`, {
                query: /* GraphQL */`query ($skip: Int, $take: Int, $sort: EngineDtoSortInput!, $filter: EngineDtoFilterInput) {
                    engineList(skip: $skip, take: $take, order: [ $sort ], where: $filter) {
                    items {
                        value: engineId
                        label: name
                        modelCode
                        year
                    }
                    totalCount
                    }
                }`,
                variables: {
                    skip: 0,
                    take: 50,
                    sort: {displayOrder: "ASC"},
                    filter: {status: {eq: true}, variantId: {eq: v}}
                }
            }).then((response) => {
                var opts = response.data?.data?.engineList?.items ? response.data.data.engineList.items : [];
                this.setState({isFetchingEngines: false, engineOpts: opts});
                if (opts.length > 0) {
                    this.handleChangeEngine(opts[0].value);
                }
            }).catch((error) => {
                console.error(error);
                this.setState({isFetchingEngines: false});
            });
        }
    }

    handleChangeEngine = (v) => {
        this.setState({engineId: v});
    }

    handleChangeState = (v) => {
        this.setState({locState: v});
    }

    getPrices = (_variant, _engine, _state) => {
        var variant = _variant || this.state.variantId;
        var engine = _engine || this.state.engineId;
        var locState = _state || this.state.locState;
        const {prices} = this.state;
        if (prices[locState] && prices[locState][engine]) {
            return;
        } else if (variant && engine && locState) {
            this.setState({isFetchingPrices: true, showErrors: false, pricesError: false});
            API.get(
                `/1/legacy/GetPrice?variantId=${variant}&state=${locState}&engineId=${engine}`
            ).then((response) => {
                // console.log(response);
                if (response.data?.data) {
                  var newPrices = {...prices};
                  newPrices[locState] = Object.assign({}, prices[locState], {[engine]: response.data.data});
                  this.setState({isFetchingPrices: false, prices: newPrices});
                } else {
                  this.setState({isFetchingPrices: false, pricesError: true});
                }
            }).catch((error) => {
                console.error(error);
                this.setState({isFetchingPrices: false, pricesError: true});
            });
        } else {
            this.setState({showErrors: true});
            return;
        }
    }

    onClickNext = () => {
        this.getPrices();
        smoothScroll.scrollTo('afs-calculator-nav');
        let engineObj = {};
        if (this.state.selectedModel && this.state.selectedVariant) {
            if (this.state.engineOpts.length && this.state.engineId) {
                engineObj = _find(this.state.engineOpts, {value: this.state.engineId});
                gtmPush(
                    "afsCalculator", "LoadVehicle", "AfsCalConfirmAVehicle",
                    {"Model": this.state.selectedModel.label, "BodyType": this.state.selectedVariant.label, "Engine": engineObj.label, "State": this.state.locState}
                );
            }
        }
    }

    onClickBack = () => {
        this.setState({prices: {}});
        smoothScroll.scrollTo('afs-calculator-nav');
    }

    onClickNextStep = (variant, prices) => {
        const {engineId, locState, engineOpts} = this.state;
        let engine = _find(engineOpts, {value: engineId});
        let data = {variant, engine, prices, locState};
        // console.log(data);
        gtmPush("afsCalculator", "Proceed", "AfsCalConfirmAVehicle");
        this.props.onSubmit(data);
    }

    render() {
        const {modelId, variantId, selectedVariant, showErrors} = this.state;
        var prices = null;
        if (this.state.prices[this.state.locState] && this.state.prices[this.state.locState][this.state.engineId]) {
            prices = this.state.prices[this.state.locState][this.state.engineId];
        }
        const loading = this.state.isFetchingEngines || this.state.isFetchingPrices;
        return (
            <div className="position-relative">
                {loading && <div className="spinner-wrapper"><Spinner isContinuous /></div>}

                {(!prices || !selectedVariant) && <div>
                    <div style={{maxWidth: '800px'}}>
                        <ModelModule
                            labelVariant="Body type"
                            colClass="col-12"
                            values={{modelId: modelId, variantId: variantId}}
                            setFieldValue={this.handleChangeVariant}
                            errors={showErrors && !variantId ? {variantId: "Please select a vehicle"} : {}}
                            touched={showErrors && !variantId ? {variantId: true} : {}}
                            form="startingPrice"
                            includeOptionObjOnChange
                            theme={this.props.theme}
                        />
                        <div className="form-field">
                            <Select name="engine"
                                label="Engine"
                                value={this.state.engineId}
                                options={this.state.engineOpts}
                                onChange={this.handleChangeEngine}
                                isInvalid={showErrors && !this.state.engineId}
                                invalidMessage="Please select an engine"
                                theme={this.props.theme === "dark" ? "light" : null}
                            />
                        </div>
                        <div className="form-field">
                            <Select name="locState"
                                label="State"
                                value={this.state.locState}
                                options={STATES_OPTIONS}
                                onChange={this.handleChangeState}
                                isInvalid={showErrors && !this.state.locState}
                                invalidMessage="Please select a state"
                                theme={this.props.theme === "dark" ? "light" : null}
                            />
                        </div>
                    </div>
                    <div className="text-right my-5">
                        <PrimaryButton label="Next" onClick={this.onClickNext} theme={this.props.theme === "dark" ? "light" : null} />
                        {this.state.pricesError && <p className="aui-color-text-red py-3">An error occured while getting pricing.</p>}
                    </div>
                    
                    <div className="row align-items-center">
                        <div className="col-12 col-xsmall-6">
                            <img src={`${process.env.PUBLIC_PATH}img/800x450_InlineMediaGallery_AQ8_D_181008.jpg`} alt="" />
                        </div>
                        <div className="col-12 col-xsmall-6">
                            <p className="aui-headline-5">Discover Models</p>
                            <p>With a wide range of models, you'll find the perfect Audi to suit your lifestyle.</p>
                            <TextButton label="View the range"
                                href="https://www.audi.com.au/au/web/en/model-range.html"
                                target="_blank"
                                onClick={() => { gtmPush("afsCalculator", "LearnMore", "AfsCalConfirmAVehicle"); }}
                                theme={this.props.theme === "dark" ? "light" : null}
                            />
                        </div>
                    </div>
                </div>}

                {prices && selectedVariant && <div>
                    <p>Confirm your vehicle</p>
                    <h4 className="aui-headline-3 mb-3">{selectedVariant.label}</h4>

                    <div className="row">
                        <div className="col-12 col-small-7">
                            <img src={prices.ImagePath} alt="vehicle image" />
                            {FEATURE_STATS && <div className="aui-color-gray90 vehicle-stats px-3 pt-3 mb-5">
                                <div className="row align-items-center">
                                    <div className="col-6 col-xsmall-3 col-small-6 col-medium-3 pb-3 d-flex align-items-center">
                                        <IconVelocity small />
                                        <span className="d-inline-block ms-1">4.9 seconds</span>
                                    </div>
                                    <div className="col-6 col-xsmall-3 col-small-6 col-medium-3 pb-3 d-flex align-items-center">
                                        <IconCubicCapacity small />
                                        <span className="d-inline-block ms-1">1,984</span>
                                    </div>
                                    <div className="col-6 col-xsmall-3 col-small-6 col-medium-3 pb-3 d-flex align-items-center">
                                        <IconTorque small />
                                        <span className="d-inline-block ms-1">400 / 2,000 - 5,200</span>
                                    </div>
                                    <div className="col-6 col-xsmall-3 col-small-6 col-medium-3 pb-3 d-flex align-items-center">
                                        <IconPower small />
                                        <span className="d-inline-block ms-1">221kW</span>
                                    </div>
                                </div>
                            </div>}
                            {FEATURE_STATS && <div className="vehicle-stats__legend mb-5">
                                <p className="title mb-3">Legend</p>
                                <div className="row">
                                    <div className="col-6 pb-2">
                                        <IconVelocity small /> Acceleration
                                    </div>
                                    <div className="col-6 pb-2">
                                        <IconCubicCapacity small /> Displacement
                                    </div>
                                    <div className="col-6 pb-2">
                                        <IconTorque small /> Max. Torque
                                    </div>
                                    <div className="col-6 pb-2">
                                        <IconPower small /> Max. Power
                                    </div>
                                </div>
                            </div>}
                        </div>
                        <div className="col-12 col-small-5">
                            <div className="row price__row">
                                <div className="col">
                                    <p className="label">Vehicle price:</p>
                                </div>
                                <div className="col text-right">
                                    <p className="price__amount">{prices.VehicleDriveAwayPrice}</p>
                                </div>
                            </div>
                            <hr className="my-5" />
                            <div className="text-right">
                                <PrimaryButton label="Proceed to finance" onClick={() => { this.onClickNextStep(selectedVariant, prices); }} theme={this.props.theme === "dark" ? "light" : null} />
                            </div>
                        </div>
                    </div>

                    <div>
                        <TextButton label="Back" className="back" onClick={this.onClickBack} theme={this.props.theme === "dark" ? "light" : null} />
                    </div>
                </div>}
            </div>
        );
    }
}

export default StepVehicle;
